// === Descarga/preview de archivos (img o video) ===
document.querySelectorAll('.item-descarga').forEach(item => {
  item.addEventListener('click', () => {
    const modal = document.getElementById('modal-descarga');
    const imgEl = document.getElementById('modal-img');
    const videoEl = document.getElementById('modal-video'); // <-- AÑADE este <video> en tu HTML si aún no existe
    const tituloEl = document.getElementById('modal-titulo');

    // Limpia previsualizaciones anteriores
    resetPreview();

    // Si el item lleva ya una miniatura, muéstrala como placeholder
    if (imgEl && item.dataset.img) {
      imgEl.src = item.dataset.img;
      imgEl.style.display = '';
    }

    if (tituloEl) tituloEl.innerText = item.dataset.nombre || '';
    modal.dataset.slug = item.dataset.slug || '';
    modal.style.display = 'flex';
  });
});

// Cerrar modal
if (document.querySelector('.modal-content .close')) {
  document.querySelector('.modal-content .close').addEventListener('click', () => {
    const modal = document.getElementById('modal-descarga');
    const imgEl = document.getElementById('modal-img');
    const videoEl = document.getElementById('modal-video');
    const input = document.getElementById('codigo-input');

    modal.style.display = 'none';
    if (input) input.value = '';
    resetPreview();
  });
}

// Utilidades comunes
const showNotFound = () => Swal.fire({
  icon: 'error',
  title: 'Archivo no encontrado',
  text: 'No se ha encontrado ningún archivo con ese código. Verifica que esté bien escrito.',
  confirmButtonText: 'Entendido'
});

// HEAD para comprobar existencia (mejor que cargar la imagen/vídeo entero)
const headExists = async (url) => {
  try {
    const res = await fetch(url, { method: 'HEAD', cache: 'no-store' });
    // Si tu servidor no soporta HEAD, cambia a GET:
    // const res = await fetch(url, { method: 'GET', cache: 'no-store' });
    return res.ok ? { ok: true, type: res.headers.get('content-type') || '' } : { ok: false, type: '' };
  } catch (e) {
    return { ok: false, type: '' };
  }
};

// Resuelve el primer asset disponible por orden de extensión
const resolveAsset = async (slug, codigo, extensiones) => {
  for (const ext of extensiones) {
    const url = `/storage/descargables/${slug}/${codigo}.${ext}`;
    const head = await headExists(url);
    if (head.ok) return { url, ext, mime: head.type };
  }
  return null;
};

// Atajo para Enter en el input (lanza preview)
(() => {
  const input = document.getElementById('codigo-input');
  const btnPreview = document.getElementById('btn-preview');
  if (input && btnPreview) {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        btnPreview.click();
      }
    });
  }
})();

// --- Limpieza segura de imagen/vídeo (usar en todas las salidas y aperturas)
const resetPreview = () => {
  const imgEl = document.getElementById('modal-img');
  const videoEl = document.getElementById('modal-video');

  if (imgEl) {
    imgEl.removeAttribute('src');
    imgEl.style.display = 'none';
  }

  if (videoEl) {
    try { videoEl.pause(); } catch {}
    // Elimina todas las <source> para forzar re-inicialización limpia en Chrome/mac
    while (videoEl.firstChild) videoEl.removeChild(videoEl.firstChild);
    videoEl.removeAttribute('src');
    videoEl.load?.(); // descartar buffers previos
    videoEl.style.display = 'none';
  }
};


// === BOTÓN DESCARGAR/VERIFICAR ===
if (document.getElementById('btn-verificar')) {
  document.getElementById('btn-verificar').addEventListener('click', async () => {
    const input = document.getElementById('codigo-input');
    const modal = document.getElementById('modal-descarga');
    const extensiones = ['jpg', 'jpeg', 'png', 'webp', 'mp4'];

    const codigo = (input?.value || '').trim();
    const slug = modal?.dataset.slug || '';
    if (!codigo || !slug) return;

    const asset = await resolveAsset(slug, codigo, extensiones);
    if (!asset) return showNotFound();

    // Si quieres pasar ext al backend:
    // window.location.href = `/descargar/${slug}?codigo=${codigo}&ext=${asset.ext}`;
    window.location.href = `/descargar/${slug}?codigo=${codigo}`;
  });
}

// === BOTÓN PREVIEW ===
if (document.getElementById('btn-preview')) {
  document.getElementById('btn-preview').addEventListener('click', async () => {
    const input = document.getElementById('codigo-input');
    const modal = document.getElementById('modal-descarga');
    const imgEl = document.getElementById('modal-img');
    const videoEl = document.getElementById('modal-video');
    const extensiones = ['jpg', 'jpeg', 'png', 'webp', 'mp4'];

    const codigo = (input?.value || '').trim();
    const slug = modal?.dataset.slug || '';
    if (!codigo || !slug) return;

    const asset = await resolveAsset(slug, codigo, extensiones);
    if (!asset) return showNotFound();

    // Oculta ambos y muestra el que toca
    resetPreview();

    if (['jpg', 'jpeg', 'png', 'webp'].includes(asset.ext)) {
      if (imgEl) {
        imgEl.src = asset.url;
        imgEl.style.display = '';
      }
    } else if (asset.ext === 'mp4') {
      if (videoEl) {
        // Creamos <source type="video/mp4"> para que Chrome/mac inicialice el decodificador correctamente
        const source = document.createElement('source');
        source.setAttribute('src', asset.url);
        source.setAttribute('type', 'video/mp4');
        videoEl.appendChild(source);

        // Ajustes recomendados
        videoEl.preload = 'metadata';
        videoEl.setAttribute('playsinline', '');         // útil en entornos WebKit
        videoEl.setAttribute('crossorigin', 'anonymous'); // por si hay CORS/CDN

        // Mostrar y preparar
        videoEl.style.display = '';
        videoEl.load();

        // Intento de reproducción tras gesto de usuario (el click en "VER")
        try {
          await videoEl.play();
        } catch (e) {
          // Silencioso si el navegador requiere click explícito en el botón de play
          // console.warn('Autoplay bloqueado o requisito de interacción directa:', e);
        }
      }
    }
  });
}
